import { useRef, useEffect } from "react";
import _ from "lodash";
import { Card } from 'antd';
import { useDataStore } from "../../../store";
import { parseIndustryData } from "./utils";
import echarts from "../../../themes/roma";

//整体场景交易概览
export function AllIndustryModule (){
    const ref = useRef();
    const chartRef = useRef();
    const categoryMonthly = useDataStore(state => state.categoryMonthly);
    useEffect(() => {
        if( categoryMonthly ){
            //机构数
            //周期履约金额
            //月均履约金额
            let LeaseData = parseIndustryData( categoryMonthly, 'Lease' );
            let UsuryData = parseIndustryData( categoryMonthly, 'Usury' );
            let FinancialData = parseIndustryData( categoryMonthly, 'Financial' );
            const chartsOptions = {
                title: {},
                legend: {},
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross',
                        crossStyle: {
                            color: '#ccc'
                        }
                    }
                },
                xAxis: {
                    type: 'category',
                    axisTick: {
                        alignWithLabel: true
                    },
                    data: [
                        '租赁机构:' + LeaseData.totalPartys, 
                        '借贷机构:' + UsuryData.totalPartys, 
                        '消费金融机构:' + FinancialData.totalPartys
                    ]
                },
                yAxis: {
                    axisLine: {
                        show: false
                    },
                    axisTick: {
                        show: false
                    }
                },
                series: [
                    {
                        name: '周期履约金额',
                        type: 'bar',
                        data: [LeaseData.totalExpense, UsuryData.totalExpense, FinancialData.totalExpense]
                    },
                    {
                        name: '月均履约金额',
                        type: 'bar',
                        data: [LeaseData.avgExpense, UsuryData.avgExpense, FinancialData.avgExpense]
                    }
                ]
            };
            if( !chartRef.current ) {
                chartRef.current = echarts.init(ref.current, 'roma');
            }
            chartRef.current.setOption(chartsOptions);
        }
    }, [ categoryMonthly ]);

    return <Card title="整体场景交易概览">
        <div ref={ref} className="charts"></div>
    </Card>;
}
